<template>
    <div class="landing-page">

        <div class="container">


            <div class="header">
                <a href="/">
                    <img class="logo" src="/images/logo.svg" alt="California Electrical Training">
                </a>
                <h1 class="font-app-medium mb-2 mt-2">Programa de Entrenamiento Electrico </h1>
            </div>

            <video class="video-player" controls>
                <source :src="this.url" type="video/mp4">
                Your browser does not support the video tag.
            </video>

            <div class="information">
                <a href="/electrical-training-program?#how-to-apply" class="btn btn-link">
                    Registrarme Ahora
                </a>
                <a href="/electrical-training-program" class="btn btn-link">
                    Más Información
                </a>
                <a href="/contact" class="btn btn-link">
                    Contactanos
                </a>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        url: {
                type:String,
                required: true,
            }
        },
}
</script>
